let actionDictionary = {};

const isCacheObsolete = (cacheKey, metaCacheTime) => new Date().getTime() - actionDictionary[cacheKey] >= metaCacheTime;

export const generateCacheKey = (actionType, actionPayload) => {
    let actionCopy = { ...actionPayload };
    delete actionCopy.type;
    delete actionCopy.meta;

    return `${actionType}-${btoa(JSON.stringify(actionCopy))}`;
};

export const getCacheValue = (cacheKey) => actionDictionary[cacheKey];

const cacheRequestsMiddleware = () => (next) => (action) => {
    if (!action.type) {
        return next(action);
    }

    if (action.type.includes('LOGOUT')) {
        actionDictionary = {};
    }

    if (action.type.includes('FAIL')) {
        let nonFailAction = action.type.replace(/FAIL_|FAILED_|_FAIL|_FAILED/, '');

        const matchingCachedRequests = Object.keys(actionDictionary).filter((actionType) =>
            actionType.startsWith(nonFailAction)
        );
        if (matchingCachedRequests.length === 0) {
            return next(action);
        }

        delete actionDictionary[matchingCachedRequests[matchingCachedRequests.length - 1]];
    }

    // trigger next action if request is not cached
    if (!action.meta || !('cacheTime' in action.meta)) {
        return next(action);
    }

    const cacheKey = generateCacheKey(action.type, action);

    if (!(cacheKey in actionDictionary) || isCacheObsolete(cacheKey, action.meta.cacheTime)) {
        // generate new cache key if request has never been called or is outdated
        actionDictionary[cacheKey] = new Date().getTime();
        return next(action);
    }
};

export default cacheRequestsMiddleware;
